import React from 'react';
import ConversationHeader from './Header/ConversationHeader.js';
import "../../../assets/scss/chatBanner.scss";
import { ChatHoc, CallHoc, VideoHoc, IconLoaderHoc } from '../../../assets/images';
import { handleParticipantList, isGroupChat } from '../../../Helpers/Chat/ChatHelper';
import WebChatConversation from './Conversation/WebChatConversationHistory.js';
import Timer from '../WebCall/Timer.js';
import { formatUserIdToJid, getContactNameFromRoster, isLocalUser } from '../../../Helpers/Chat/User';
import { CHAT_TYPE_GROUP } from '../../../Helpers/Chat/Constant';
import { useSelector } from 'react-redux';
import { setGroupParticipants } from '../../../Helpers/Chat/Group.js';
import { store } from '../../../Redux/store.js';
import CustomIcon from '../../../assets/images/CustomIcon.js';

const ConversationSection = (props = {}) => {
  const storeselect = useSelector((state) => state);
  const { vCardData,
    rosterData: { data: totalContactList = [] } = {},
    activeChatData:{data:activeChatData = []},
    groupsMemberParticipantsListData: { groupParticipants = {} },
    groupMembersData:{ id: groupId }={},
    modalPopUpData = {},
    callDurationTimestamp : {callDurationTimeStamp} = {},
    recentChatItems,
    dynamicIcon
  } = storeselect;
  const { mf_Chat,mf_Call,mf_Video } = dynamicIcon?.data 
  const {
    showonGoingcallDuration = false,
    handlePopupState = () => { },
    handleShowCallScreen = () => { },
    openStatus = true,
    handleConversationSectionDisplay = () => { },
    showMessageinfo,
    messageInfoShow,
    conversationValue,
    isCallEnabled,
    otfLoader = false
    // handleMediaShow = () => { },
  } = props

  const [conversationSection, setConversationSection] = React.useState({
    groupMemberDetails: [],
    displayNames: '',
    activeChatId: '' // Selected Chat - UserId or GroupId 
  });

  React.useEffect(()=>{
    if(activeChatData.length === 1){
      constructData()
    }
    },[activeChatData])

  React.useEffect(()=>{
    if(activeChatData.length === 1){
      updateGroup()
    }
  },[groupId, recentChatItems])    

  const getGroupMembers = (participants = []) => {
    return participants && (handleParticipantList(participants, totalContactList) || [])
  }

  const sortUsersDisplayName = (groupMemberDetails = []) => {
    return groupMemberDetails.map(member => {
      const nameToDisplay = getContactNameFromRoster(member)
      member.displayName = nameToDisplay
      return member
    }).sort((b, c) => isNaN(parseInt(c.displayName)) - isNaN(parseInt(b.displayName)) || String(b.displayName).localeCompare(String(c.displayName)))
  }

  const mapUsers = (userType = null) => {
    const { participants } = store.getState()?.groupMembersData?.data || []
    const groupMemberDetails = getGroupMembers(participants)
    if (!userType) {
      return sortUsersDisplayName(groupMemberDetails)
    }
    const filterMember = groupMemberDetails.filter(users => users.userType === userType)
    return sortUsersDisplayName(filterMember)
  }
  
  const sortUsersByName = (userType = null) => {
    let response = userType ? mapUsers('o').concat(mapUsers('n')) : mapUsers()
    let index = response.findIndex((o) => isLocalUser(o.userId))
    if (index !== -1) {
      let activeUser = response.splice(index, 1)[0];
      response.push({
        ...activeUser, ...vCardData?.data, displayName: 'You',
      })
    }
    return response
  }

  const displayGroupMemberNames = async () => {
    let memberNames = []
    await sortUsersByName().map(async (member) => {
      if (member.userType && member.displayName) {
        memberNames.push(member.displayName);
      }
    });
    const { participants } = store.getState()?.groupMembersData?.data
    const groupMemberDetails = getGroupMembers(participants).filter(users => users.userType);
    if (groupMemberDetails.length === memberNames.length) {
      return memberNames.join(", ");
    } else {
      return "click here for group info";
    }
  }

  const updateGroup = async () => {
    let response = sortUsersByName('o')
    let displayNames = await displayGroupMemberNames()
    setConversationSection({
      ...conversationSection,
      groupMemberDetails: response,
      displayNames: displayNames
    })
  }

  const constructData = () => {
    const [{chatType="", chatId=""} ]= activeChatData
      if (isGroupChat(chatType)) {
        const groupJid = formatUserIdToJid(chatId, CHAT_TYPE_GROUP);
        const participants = groupParticipants[groupJid];
        if (participants && participants.length > 0) {
           setGroupParticipants({
            "groupJid": groupJid,
            "participants": participants
          });
        }
  }
}

  /**
  // const handlePopUpClassActive = (status) => {
  //   handlePopupState(status);
  // };
  */

  const nickname = vCardData?.data?.nickName || vCardData?.data?.userId || '';
  return (
    <React.Fragment>
      {(activeChatData && activeChatData.length === 0) ?
        !otfLoader ? <div className='otf_loader_chat'><IconLoaderHoc/></div> : <div className={` chat-banner ${showonGoingcallDuration ? 'showCallDuration' : ''} `}>
          {showonGoingcallDuration &&
            <div className="onGoingcallDuration" onClick={handleShowCallScreen}>
              <span className="tapToCall">Tap to return to call {callDurationTimeStamp && <> - <Timer callStatus="" callDurationTimestamp={callDurationTimeStamp} /></>}</span>
            </div>
          }
          <div className="banner-blocks">
            <div className="mf-section">
              <div className="start-chart">
                <div className="content">
                  <h3>Hi 
                    {" " +nickname}
                    {nickname && '!'}</h3>
                  <p>Try the wholesome experience of MirrorFly</p>
                  <div className="start-chat">
                    <span><i className="iconChating"><CustomIcon icon={mf_Chat ? mf_Chat : <ChatHoc viewBox="0 0 20.978 20.348" />} {...props} /></i>Chatting</span>
                    
                    {  isCallEnabled &&
                    <span>
                     <i className="iconVoice">  <CustomIcon icon={mf_Call ? mf_Call : <CallHoc viewBox="0 0 23.788 23.788"/>} {...props} /></i>Voice
                     </span>
                     }
                       {  isCallEnabled &&
                    <span><i className="iconVideo">  <CustomIcon icon={mf_Video ? mf_Video : <VideoHoc viewBox="0 0 22.5 13.944"/>} {...props} /></i>Video</span>
                       }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        :
        <div className={`chat-conversion ${openStatus ? 'popup-open' : ''} ${modalPopUpData.modalPopup ? 'modal-open' : ''}
            ${showonGoingcallDuration ? 'showCallDuration' : ''}`}>
          {showonGoingcallDuration &&
            <div className="onGoingcallDuration" onClick={handleShowCallScreen}>
              <span className="tapToCall">Tap to return to call {callDurationTimeStamp && <> - <Timer callStatus="" callDurationTimestamp={callDurationTimeStamp} /></>} </span>
            </div>
          }
              <ConversationHeader
                userData={activeChatData}
                vCardData={vCardData}
                conversationValue={conversationValue}
                showonGoingcallDuration={showonGoingcallDuration}
                activeChatId={activeChatData[0]?.chatId}
                displayNames={conversationSection.displayNames}
                groupMemberDetails={conversationSection.groupMemberDetails}
                handlePopUpClassActive={handlePopupState}
                handleConversationSectionDisplay={handleConversationSectionDisplay}
                isCallEnabled = {isCallEnabled}
              />
          <WebChatConversation
            activeChatId={activeChatData[0]?.chatId}
            showMessageinfo={showMessageinfo}
            messageInfoShow={messageInfoShow}
            avoidRecord={showonGoingcallDuration}
            handleShowCallScreen={handleShowCallScreen}
            activeChatData={activeChatData[0]}
            activeSelectData={activeChatData}
            handleMediaShow={props.handleMediaShow}
          />
        </div>
      }
    </React.Fragment>
  )
}

export default ConversationSection;
